import { inject, Injectable } from '@angular/core';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import { Observable } from 'rxjs';
import {
  EmailTemplatePreviewResponse,
  EmailTemplatesResponse,
  EmailTemplateType,
  EmailTemplateVariables
} from '../models/email-templates.models';

@Injectable({
  providedIn: 'root'
})
export class EmailTemplateService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  geEmailTemplateContent(
    templateType: EmailTemplateType,
    projectId?: string | null
  ): Observable<EmailTemplatesResponse> {
    return this.#http.getData<EmailTemplatesResponse>(
      `${this.baseUrl}/email-templates/${templateType}${this.#projectQuery(projectId)}`,
      { showLoader: true, showMessage: false }
    );
  }

  getEmailTemplatesVariables(templateType: EmailTemplateType): Observable<EmailTemplateVariables> {
    return this.#http.getData<EmailTemplateVariables>(`${this.baseUrl}/email-templates/${templateType}/variables`, {
      showLoader: true,
      showMessage: false
    });
  }

  previewEmailTemplate(templateType: EmailTemplateType, htmlContent: string): Observable<EmailTemplatePreviewResponse> {
    return this.#http.postData<EmailTemplatePreviewResponse>(
      `${this.baseUrl}/email-templates/${templateType}/preview`,
      { showLoader: false, showMessage: false },
      { htmlContent }
    );
  }

  saveEmailTemplateContent(
    htmlContent: string,
    templateType: EmailTemplateType,
    projectId?: string | null
  ): Observable<void> {
    return this.#http.postData<void>(
      `${this.baseUrl}/email-templates/${templateType}${this.#projectQuery(projectId)}`,
      { showLoader: true, showMessage: true },
      { htmlContent }
    );
  }

  deleteProjectTemplate(templateType: EmailTemplateType, projectId: string): Observable<void> {
    return this.#http.deleteData<void>(
      `${this.baseUrl}/email-templates/${templateType}${this.#projectQuery(projectId)}`,
      {
        showLoader: true,
        showMessage: true,
        message: 'Project template removed; the project now uses the default'
      }
    );
  }

  #projectQuery(projectId?: string | null): string {
    return projectId ? `?projectId=${encodeURIComponent(projectId)}` : '';
  }
}
